export const tourGuideSteps = [
  {
    selector: "#entitlement-header-1",
    content:
      "This area provides a brief summary of the client and environment details.",
  },
  {
    selector: "#entitlement-header-2",
    content:
      "This area provides a brief summary of the allotment and the number of entitlements being used. The number of used entitlements cannot exceed the allotment.",
  },
  {
    selector: "#entitlement-data-grid-buttons",
    content:
      "These buttons allow you to reset changes or save your entitlement selections.",
  },
  {
    selector: "#Channels-column-2",
    content:
      "This column allows you to select or unselect channels to use the monitoring entitlement. Use the Select All/Unselect All buttons in the header or individual checkboxes per channel.",
  },
  {
    selector: "#Channels-column-3",
    content:
      "This column allows you to select or unselect channels to use the archiving entitlement. Use the Select All/Unselect All buttons in the header or individual checkboxes per channel.",
  },
];
